import { useCallback, useRef } from 'react';

const useChatScrollToBottom = () => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const lastAgentMessageRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = useCallback((smooth = false) => {
    messagesEndRef.current?.scrollIntoView({
      behavior: smooth ? 'smooth' : 'instant',
      block: 'end',
    });
  }, []);

  const scrollToLastAgentMessage = useCallback(() => {
    lastAgentMessageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [lastAgentMessageRef.current]);

  return {
    scrollToBottom,
    messagesEndRef,
    lastAgentMessageRef,
    scrollToLastAgentMessage,
  };
};

export default useChatScrollToBottom;
